module.exports = __webpack_public_path__ + "media/images/sponsorBox__bg-54758f779ba6f18ba57f1cd80e2fcfd0.jpg";